import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/HelpOutlineOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import ArrowRightOutlinedIcon from '@mui/icons-material/ArrowRightOutlined';
import { Box, Button, DialogContent, Divider, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { PlaceOutlined, PhoneOutlined } from '@mui/icons-material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BuyerInfoViewProps } from './BuyerInfoDialog';

export default function BuyerInfoInvoicingView({ close, changeView, hideBackArrow }: BuyerInfoViewProps): React.JSX.Element {
  const { t } = useTranslation(['common', 'contracts']);

  return (
    <DialogContent
      sx={{
        p: 2,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Button
            variant="text"
            onClick={() => changeView('GENERAL')}
            sx={{
              display: hideBackArrow ? 'none' : undefined,
            }}
          >
            <ArrowBackIcon />
          </Button>
          <ReceiptLongOutlinedIcon sx={{ mx: 1 }} />
          <Typography variant="titleMedium" sx={{ flex: 1 }}>
            {t('common:billing')}
          </Typography>
          <Button variant="text" onClick={close}>
            <CloseIcon />
          </Button>
        </Box>
        <Typography variant="bodySmall" color="secondary">
          {t('contracts:buyer_invoicing_information')}
        </Typography>
      </Box>

      <Box
        sx={{
          overflow: 'auto',
        }}
      >
        <List>
          <ListItemButton onClick={() => changeView('INVOICING_ADDRESS')}>
            <ListItemIcon>
              <PlaceOutlined />
            </ListItemIcon>
            <ListItemText primary={t('contracts:invoicing_address')} />
            <ListItemIcon>
              <ArrowRightOutlinedIcon />
            </ListItemIcon>
          </ListItemButton>
          <Divider />
          <ListItemButton onClick={() => changeView('INVOICING_CONTACT')}>
            <ListItemIcon>
              <PhoneOutlined />
            </ListItemIcon>
            <ListItemText primary={t('contracts:invoicing_contacts')} />
            <ListItemIcon>
              <ArrowRightOutlinedIcon />
            </ListItemIcon>
          </ListItemButton>
          <Divider />
          <ListItemButton onClick={() => changeView('INVOICING_HOW_TO')}>
            <ListItemIcon>
              <HelpIcon />
            </ListItemIcon>
            <ListItemText primary={t('contracts:invoicing_how_to_send_invoices')} />
            <ListItemIcon>
              <ArrowRightOutlinedIcon />
            </ListItemIcon>
          </ListItemButton>
        </List>
      </Box>
    </DialogContent>
  );
}
